module.exports = __webpack_public_path__ + "img/firmamarcelo.60c82cb8.png";